<template>
  <div class="noApp">
    <h1>{{ $t('messages.sharedTexts.unsupportedBrowserTitle') }}</h1>
    <p>{{ $t('messages.sharedTexts.unsupportedBrowserText') }}</p>
  </div>
</template>

<script>
export default {
  name: 'NoApp',
}
</script>

<style lang="scss">
.noApp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  text-align: center;
  background: $color-white;
  border-radius: $application-base-border-radius;
  padding: 50px;
  line-height: 1.5em;

  h1 {
    font-size: 1.5em;
  }
}
</style>
